module.exports = __webpack_public_path__ + "static/media/text-tool.e5241b8c.gif";